module.exports = __webpack_public_path__ + "img/tgd1x_inspect_front.a05a5986.png";